import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";

export class meter_readings extends entityBase {
  external_source: KnockoutObservable<string>;
  meter_reading_id: KnockoutObservable<number>;
  meter_value: KnockoutObservable<number>;
  product_id: KnockoutObservable<string>;
  reading_dttm: KnockoutObservable<Date>;
  formattedreading_dttm: any;

  constructor(item: any) {
    super();
    this.external_source = ko.observable(item.external_source).extend({ maxLength: 32 });
    this.meter_reading_id = ko.observable(item.meter_reading_id);
    this.meter_value = ko.observable(item.meter_value);
    this.product_id = ko.observable(item.product_id).extend({ maxLength: 32 });
    this.reading_dttm = ko.observable(this.formatJSONDate(item.reading_dttm));
    this.formattedreading_dttm = CustomObservables.formattedDateTimeObservable(this.reading_dttm);
  }
}
